

export function open(data = {}, store:any) {
  store.dispatch({modal: Object.assign(store.modal, {data})})
}


export function close(data = {}, store:any) {
  store.dispatch({modal: Object.assign(store.modal, {data: {}})})
}